export type TipoSelecaoAtividade = 'todos' | 'codigo-atividade' | 'numero-atividade' | 'codigo-reuniao' | 'codigo-comissao' | 'codigo-protocolo';
export type SituacaoAtividade = 'todas' | 'pendente' | 'resolvido';
export type TipoComissaoAtividade = 'todas' | 'comissao-interna' | 'camara-tecnica-interna' | 'comissao-camara-externa' | 'grupo-trabalho-interno';

export interface FiltrosAtividadesComissoes {
    tipoSelecao: TipoSelecaoAtividade;
    valorSelecao: string;
    aberturaInicio: string;
    aberturaFim: string;
    encerramentoInicio: string;
    encerramentoFim: string;
    situacao: SituacaoAtividade;
    responsavelId: number | null;
    responsavelUf: string;
    responsavelNome: string;
    descricao: string;
    tipoComissao: TipoComissaoAtividade;
}

export interface OpcaoAtividade {
    rotulo: string;
    valor: string;
}

export interface AtividadeComissao {
    codigo: string;
    status: Exclude<SituacaoAtividade, 'todas'>;
    atividade: string;
    numeroAtividade: string;
    codigoReuniao: string;
    dataInicio: Date | null;
    dataFim: Date | null;
    comissaoNucleo: string;
    responsavel: string;
    descricao: string;
    tipoComissao: Exclude<TipoComissaoAtividade, 'todas'>;
    idTarefa?: number;
    idReuniao?: number;
    idSituacaoTarefa?: number;
    descricaoSituacao?: string;
    idTipoComissaoCt?: number;
    idSolicitanteResponsavel?: number;
    ufSolicitanteResponsavel?: string;
    idEstruturaOrganizacional?: number;
    idProtocolo?: number;
    numeroProtocolo?: string;
    txObservacao?: string;
}

export const OPCOES_SELECAO_ATIVIDADE: OpcaoAtividade[] = [
    { rotulo: 'Todos', valor: 'todos' },
    { rotulo: 'Código da Atividade', valor: 'codigo-atividade' },
    { rotulo: 'Número da Atividade', valor: 'numero-atividade' },
    { rotulo: 'Código da Reunião', valor: 'codigo-reuniao' },
    { rotulo: 'Código da Comissão', valor: 'codigo-comissao' },
    { rotulo: 'Código do Protocolo', valor: 'codigo-protocolo' }
];

export const OPCOES_SITUACAO_ATIVIDADE: OpcaoAtividade[] = [
    { rotulo: 'Todas', valor: 'todas' },
    { rotulo: 'Pendente', valor: 'pendente' },
    { rotulo: 'Resolvido', valor: 'resolvido' }
];

export const OPCOES_TIPO_COMISSAO_ATIVIDADE: OpcaoAtividade[] = [
    { rotulo: 'Todos', valor: 'todas' },
    { rotulo: 'Comissão Interna', valor: 'comissao-interna' },
    { rotulo: 'Câmara Técnica Interna', valor: 'camara-tecnica-interna' },
    { rotulo: 'Comissão, Câmara Técnica ou Grupo de Trabalho Externo', valor: 'comissao-camara-externa' },
    { rotulo: 'Grupo de Trabalho Interno', valor: 'grupo-trabalho-interno' }
];

export function criarFiltrosAtividadesIniciais(): FiltrosAtividadesComissoes {
    return {
        tipoSelecao: 'todos',
        valorSelecao: '',
        aberturaInicio: '',
        aberturaFim: '',
        encerramentoInicio: '',
        encerramentoFim: '',
        situacao: 'todas',
        responsavelId: null,
        responsavelUf: '',
        responsavelNome: '',
        descricao: '',
        tipoComissao: 'todas'
    };
}
